<template>
  <UApp :locale="ro">
    <NuxtLoadingIndicator color="var(--ui-color-primary-500, #2563eb)" :height="3" />
    <NuxtLayout :key="layoutKey">
      <NuxtPage :key="pageKey" />
    </NuxtLayout>
    <CartDrawer />
    <CompareBar />
    <ProductQuickView />
    <PwaInstallBanner />
    <CookieConsentBanner />
  </UApp>
</template>

<script setup lang="ts">
import { ro } from '@nuxt/ui/locale'

const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const { fetchUser } = useAuth()
const { syncCart, pruneUnavailableItems } = useCart()
const shopSlug = useShopSlug()
const route = useRoute()

/** Remount when shop or layout changes (admin ↔ storefront) to avoid stale chrome. */
const layoutKey = computed(() => {
  const shop = shopSlug.value || 'platform'
  const layout = String(route.meta.layout ?? 'default')
  return `${shop}:${layout}`
})
const pageKey = computed(() => shopSlug.value || 'platform')

onMounted(async () => {
  cartStore.hydrateFromStorage()
  authStore.hydrateFromStorage()
  await pruneUnavailableItems({ silent: true })

  await fetchUser()
  if (authStore.isAuthenticated) {
    await syncCart()
    await wishlistStore.fetchWishlist()
  }
})
</script>
